import React, { useState, useEffect } from "react";
import CloseOutlinedIcon from "@material-ui/icons/CloseOutlined";
import {
    setTheInternalCategoryQuestionsEdtionctions,
    setTheInteralcategoryQuestionsretrieveActions,
  setTheInternalQuestionsCreateActions,
  
} from "../../../../Redux/Slice";
import { useDispatch, useSelector } from "react-redux";
import Select from "react-select";


const InternalcategoruCrud = (props) => {
  const { setShow, show, currentPage, EditID, search, isActive, setIsActive } = props;

  const dispatch = useDispatch();
  const state = useSelector((state) => state);
  const Headers = {
    name: "",
    is_active: true,
    description: "",
  };
  const [Data, setDatas] = useState(Headers);
  const [queryError, setqueryErr] = useState("");
  const [descriptionsErr, setDestionErr] = useState("");
  const [Options, setOptions] = useState([]);
  const [ScopeValue, setScopeVaues] = useState([]);
  const [ScopeSearch, setScopeSearch] = useState("");
  const [scopeerr, setscopeErr] = useState("")

  useEffect(() => {
    if (EditID != undefined && EditID != "") {
      const payload = {
        EditID: EditID,
      };
      dispatch(setTheInteralcategoryQuestionsretrieveActions(payload));
    }
  }, []);



  useEffect(() => {
    if (
      EditID != undefined &&
      EditID != "" &&
      state.internalcategoryQuestionsretrieve.internalcategoryQuestionRetrieve.id
    ) {
      setDatas({
        ...Data,
        name: state.internalcategoryQuestionsretrieve.internalcategoryQuestionRetrieve.name,
        description:
          state.internalcategoryQuestionsretrieve.internalcategoryQuestionRetrieve.description,
        is_active: state.internalcategoryQuestionsretrieve.internalcategoryQuestionRetrieve.is_active,
        // scope_id: state.internalcategoryQuestionsretrieve.internalcategoryQuestionRetrieve.scope_id?.id
      });

    }

  }, [state.internalcategoryQuestionsretrieve.internalcategoryQuestionRetrieve, EditID]);


  // Function to handle toggle
  const Handletoggle = () => {
    setDatas((prev) => ({
      ...prev,
      is_active: !prev.is_active,
    }));
  };



  const HandleChanges = (e) => {
    setDatas((pre) => {
      return {
        ...pre,
        [e.target.name]: e.target.value,
      };
    });
  };

  const HandleSubmits = (e) => {
    e.preventDefault();
  };

  const HandleSubmit = (e) => {
    var a = 0;

    if (EditID == undefined || EditID == "") {
      if (Data.description == "") {
        setDestionErr("*Description is required");
        a = 1;
      }
      if (Data.name == "") {
        setqueryErr("*Category is required");
        a = 1;
      }

      if (a == 0) {
        const payload = {
          currentPage: currentPage,
          Data: Data,
          search: search
        };

        dispatch(setTheInternalQuestionsCreateActions(payload, setShow(false)));
      }
    }


    else if (EditID != undefined || EditID != "") {

      if (Data.description == "") {
        setDestionErr("*Description is required");
        a = 1;
      }
      if (Data.name == "") {
        setqueryErr("*Category is required");
        a = 1;
      }


      if (a == 0) {
        const payload = {
          currentPage: currentPage,
          Data: Data,
          EditID: EditID,
          search: search
        };

        dispatch(setTheInternalCategoryQuestionsEdtionctions(payload, setShow(false)));
      }
    }
  };

  return (
    <>
      <div className="RoleCreatePopup">
        <div className="BeforePopUp">
          <div className="RolePopups" style={{ width: "30%" }}>
            <div className="asds">
              <div class="ModalHeader">
              <span className="UserCreate">Category </span>


                <div className="CloseIcon" onClick={(e) => setShow(false)}>
                  <CloseOutlinedIcon />
                </div>
              </div>
              <form class="row g-3 form-fields-wrapper" onSubmit={(e) => {
                e.preventDefault();
                HandleSubmits();
              }}
              >



                <div className="col-12 field-div">
                  <label className="form-label" style={{ fontSize: "15px" }}>
                    Category
                    <span style={{ color: "red" }}>*</span>

                  </label>
                  <input
                    type="text"
                    class="form-control"
                    value={Data.name}
                    autoComplete="off"
                    onChange={(e) => {
                      HandleChanges(e);
                      setqueryErr("");
                    }}
                    required
                    name="name"
                    style={{
                      padding: "10px",
                    }}
                  ></input>
                  <p style={{ color: "red", marginTop: "5px" }}>{queryError}</p>
                </div>

                <div className="col-12 field-div">
                  <label className="form-label" style={{ fontSize: "15px" }}>
                    Description
                    <span style={{ color: "red" }}>*</span>

                  </label>
                  <input
                    type="text"
                    class="form-control"
                    value={Data.description}
                    autoComplete="off"
                    onChange={(e) => {
                      HandleChanges(e);
                      setDestionErr("");
                    }}
                    required
                    name="description"
                    style={{
                      padding: "10px",
                    }}
                  ></input>
                  <p style={{ color: "red", marginTop: "5px" }}>
                    {descriptionsErr}
                  </p>
                </div>


                <div className="col-6 field-div ActiveStatusSub">
                  <label htmlFor="isActiveToggle" className="toggleLabel">Is Active                                          <input
                    type="checkbox"
                    id="isActiveToggle"
                    name="isActive"
                    onChange={Handletoggle}


                    className="toggleInput"
                    checked={Data.is_active}
                  /></label>
                  <div className="toggleSwitch">

                    <span className="slider"></span>
                  </div>
                </div>

              </form>
              <div
                className="RoleButton"
                style={{
                  display: "flex",
                  gap: "15px",
                  justifyContent: "flex-end",
                  alignItems: "center",
                }}
              >

                {/* <button
                  class="btn CancelBtn"
                  onClick={(e) => setShow(false)}
                >
                  Cancel
                </button> */}

                <button
                  class="btn  Createbuttonpop"
                  type="submit"
                  onClick={(e) => {
                    HandleSubmit(e);
                  }}
                >
                  Submit
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default InternalcategoruCrud;
